import { all, AllEffect, ForkEffect, put, takeLatest } from 'redux-saga/effects'
import { showUnavailableFeaturePopup } from './actions'
import { unavailableFeatureTypes } from './actionTypes'
import { handleUnavailableFeaturePopupErrorRequest } from './types'

function* handleUnavailableFeaturePopupError(
    action: handleUnavailableFeaturePopupErrorRequest,
) {
    const { message } = action.payload
    if (message.includes('Show popup')) {
        yield put(showUnavailableFeaturePopup())
    }
}

function* handleUnavailableFeaturePopupErrorSaga(): Generator<
    AllEffect<ForkEffect<never>>,
    void,
    unknown
> {
    yield all([
        takeLatest(
            unavailableFeatureTypes.HANDLE_UNAVAILABLE_FEATURE_POPUP_ERROR,
            handleUnavailableFeaturePopupError,
        ),
    ])
}

export default handleUnavailableFeaturePopupErrorSaga
